import React from 'react';
import IntroSection from './IntroSection';
import BenefitGrid from './BenefitGrid';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

export default function JobCulture({news}) {
    const {locale} = useRouter();

    if (!news || news.length === 0) {
        return <p>{getLocaleContent(locale, 'page.recruitment.no_news')}</p>;
    }

    const firstNews = news[0];
    const otherNews = news.slice(1);

    return (
        <section className="culture-section">
            {/* IntroSection chỉ dùng 1 tin đầu */}
            <IntroSection item={firstNews} />

            {/* BenefitGrid render danh sách các tin còn lại */}
            {otherNews.length > 0 && <BenefitGrid items={otherNews} />}
        </section>
    );
}
